import React from 'react'

import { Grid, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import { Controller } from 'react-hook-form'

const PlanForm = ({ isDisbled, formMethods }) => {
  const { control, errors } = formMethods

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="O que? *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.planWhat}
              helperText={errors?.planWhat?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="planWhat"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="Por que? *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.planWhy}
              helperText={errors?.planWhy?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="planWhy"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="Onde? *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.planWhere}
              helperText={errors?.planWhere?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="planWhere"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="Como? *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.planHow}
              helperText={errors?.planHow?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="planHow"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="Quanto? *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.planHowMuch}
              helperText={errors?.planHowMuch?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="planHowMuch"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="Recursos? *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.planResources}
              helperText={errors?.planResources?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="planResources"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          control={control}
          as={
            <TextField
              label="Quem? *"
              type="text"
              color="primary"
              variant="outlined"
              error={!!errors.planWho}
              helperText={errors?.planWho?.message}
              fullWidth
              disabled={isDisbled}
            />
          }
          name="planWho"
          mode="onBlur"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          as={
            <KeyboardDatePicker
              fullWidth
              format="DD/MM/yyyy"
              label="Quando?"
              helperText={errors?.planWhen?.message}
              error={!!errors.planWhen}
              inputVariant="outlined"
              onChange={(newValue) => ({ value: newValue })}
              disabled={isDisbled}
            />
          }
          control={control}
          defaultValue={null}
          name="planWhen"
          mode="onChange"
        />
      </Grid>
    </Grid>
  )
}

export default PlanForm
